<template>
  <router-view/>
</template>

<script>
import auth from '@/utils/auth'

import { mapGetters, mapActions } from 'vuex'

let interval = null

export default {
  name: 'App',
  computed: {
    ...mapGetters('user', ['isAuth'])
  },
  methods: {
    ...mapActions({
      setLanguages: 'languages/setLanguages',
      refreshToken: 'user/refreshToken'
    })
  },
  watch: {
    isAuth: {
      immediate: true,
      handler () {
        if (this.isAuth) {
          interval = setInterval(() => {
            const now = Date.now()
            const diff = Number(auth.tokenExp) - now
            if (diff <= 30000) {
              this.refreshToken()
            }
          }, 30000)
        } else {
          clearInterval(interval)
          if (!this.$route.meta.ignoreAuth) {
            this.$router.replace({ name: 'login' })
          }
        }
      }
    }
  },
  created () {
    this.setLanguages()
  },
  destroyed () {
    clearInterval(interval)
  }
}
</script>

<style>
  tr:hover {
    cursor: pointer;
  }
</style>
